import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useState, useCallback, useImperativeHandle, useEffect } from "react";
import PropTypes from "prop-types";
import { SelectListOuter, SelectListInner } from "./select-list.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  initialScrollPosition: PropTypes.number
};
const defaultProps = {
  initialScrollPosition: 0
};
const SelectList = forwardRef(
  ({ children, initialScrollPosition }, forwardedRef) => {
    const ref = useRef();
    const [fadeTop, setFadeTop] = useState(false);
    const [fadeBottom, setFadeBottom] = useState(false);
    const handlePositionChange = useCallback((elem) => {
      const { offsetHeight, scrollHeight, scrollTop } = elem;
      setFadeTop(scrollTop > 0);
      setFadeBottom(scrollTop + offsetHeight < scrollHeight);
    }, []);
    const handleScroll = useCallback(
      (event) => {
        handlePositionChange(event.currentTarget);
      },
      [handlePositionChange]
    );
    useImperativeHandle(forwardedRef, () => ref.current);
    useEffect(() => {
      if (initialScrollPosition > 0) {
        ref.current.scrollTop = initialScrollPosition;
      }
    }, [initialScrollPosition]);
    useEffect(() => {
      const elem = ref.current;
      if (typeof ResizeObserver === "undefined") {
        return;
      }
      const resizeObserver = new ResizeObserver((entries) => {
        Array.from(entries).forEach((entry) => {
          handlePositionChange(entry.target);
        });
      });
      resizeObserver.observe(elem);
      return () => {
        resizeObserver.unobserve(elem);
      };
    }, [handlePositionChange]);
    return /* @__PURE__ */ jsx(SelectListOuter, { ref, onScroll: handleScroll, children: /* @__PURE__ */ jsx(
      SelectListInner,
      {
        "data-testid": "select-list-inner",
        $fadeBottom: fadeBottom,
        $fadeTop: fadeTop,
        children
      }
    ) });
  }
);
SelectList.propTypes = propTypes;
SelectList.defaultProps = defaultProps;
export {
  SelectList
};
